import script from "./DotSliderComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./DotSliderComponent.vue?vue&type=script&setup=true&lang=js"

import "./DotSliderComponent.vue?vue&type=style&index=0&id=790559e7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-790559e7"]])

export default __exports__